import React, { useMemo } from "react";

import Address from "@mapmycustomers/shared/types/Address";
import Located from "@mapmycustomers/shared/types/base/Located";

import { getFormattedAddressForUi } from "@app/util/formatters";

interface Props {
  address?: Located;
  className?: string;
}

const SingleLineAddress: React.FC<Props> = ({ address, className }) => {
  const formattedAddress = useMemo(() => getFormattedAddressForUi(address as Address), [address]);

  return address ? <div className={className}>{formattedAddress}</div> : null;
};

export default SingleLineAddress;
